import React from 'react';
import Slide from "react-slick";
import { SliderSettings } from '../../../utils/SliderSetting';
import { Feature } from './Feature';
import { ReasonItem } from './ReasonItem/ReasonItem';
import styles from './Reasons.module.scss';

export const Reasons: React.FC = () => {
    const features = Feature.PRO_FEATURES;

    return (
        <div className={styles.reasons}>
            <Slide {...SliderSettings()} dots={true}>
                {features.map((feature, index) => (
                    <ReasonItem key={index}
                        feature={feature}
                    />
                ))}
            </Slide>
        </div>
    );
};
